export default "__VITE_ASSET__LfieVZD7__"